import React, { memo } from "react";
import { classNames, useTranslate } from "helpers";
import { VehiclePickerSummaryProps } from "./types";
import VehicleCard from "../VehicleCard/VehicleCard";

const VehiclePickerSummary: React.FC<VehiclePickerSummaryProps> = ({
  vehicleInfo,
  stepCurrent,
  onSelectStep,
}) => {
  const { t } = useTranslate();

  const thisStep = 0;
  if (stepCurrent === thisStep) {
    return null;
  }

  const isActive = stepCurrent === thisStep;
  const isCompleted = stepCurrent > thisStep;

  return (
    <VehicleCard
      vehicleInfo={vehicleInfo}
      isActive={isActive}
      isCompleted={isCompleted}
      step={1}
      title={"Odabir vozila"}
      className={classNames(
        `
        bg-white rounded-md border border-blue-100 shadow-2xl
        absolute top-1/2 left-1/2
        -translate-x-1/2 -translate-y-1/2
        w-full max-w-[300px]
        animate-tiltIn
        transition-transform duration-300
        `,
        isActive
          ? "opacity-100 scale-100 ring-2 ring-blue-500"
          : "opacity-70 hover:opacity-100 hover:rotate-[-2deg]"
      )}
    />

    // <div
    //   ref={ref}
    //   role="button"
    //   tabIndex={0}
    //   onClick={onSelectStep}
    //   onKeyDown={(e) => e.key === "Enter" && onSelectStep?.()}
    //   className={classNames(
    //     `
    //     bg-white rounded-md border border-blue-100 shadow-2xl
    //     absolute top-1/2 left-1/2
    //     -translate-x-1/2 -translate-y-1/2
    //     w-full max-w-[300px]
    //     animate-tiltIn
    //     transition-transform duration-300
    //     cursor-pointer
    //     `,
    //     isActive
    //       ? "opacity-100 scale-100 ring-2 ring-blue-500"
    //       : "opacity-70 hover:opacity-100 hover:rotate-[-2deg]"
    //   )}
    // >
    //   <div className="p-3 flex justify-between items-center min-h-[52px]">
    //     <h3 className="text-sm font-semibold text-slate-800">
    //       {thisStep + 1}. Vozilo
    //     </h3>

    //     {isCompleted && (
    //       <div className="bg-green-50 border-2 border-green-500 rounded-full p-1">
    //         <ReactSVG
    //           src="/media/icons/check.svg"
    //           className="w-4 h-4 fill-green-500 stroke-green-500"
    //         />
    //       </div>
    //     )}
    //   </div>

    //   {vehicleInfo.vehicleImage && (
    //     <div className="bg-white pt-4 pb-6 px-6">
    //       <img
    //         src={vehicleInfo.vehicleImage}
    //         className="w-full h-auto object-contain"
    //       />
    //     </div>
    //   )}

    //   <div>
    //     <div className="p-4">
    //       <h3 className="text-lg font-semibold text-slate-800">
    //         {vehicleInfo.vehicleManufacturerName}
    //       </h3>
    //       <p className="text-sm text-slate-600">
    //         {vehicleInfo.vehicleModelName}
    //       </p>
    //       <p className="text-xs text-slate-500 mt-1">
    //         {vehicleInfo.vehicleTypeName}
    //       </p>
    //     </div>

    //     <div className="border-t border-slate-200 pt-3 p-4 space-y-2">
    //       {vehicleInfo.fuelType && (
    //         <div className="flex justify-between text-sm">
    //           <span className="text-slate-500">
    //             {t("admin.fleet.vehicle.add.vehicle.fueltype")}
    //           </span>
    //           <span className="text-slate-700 font-medium">
    //             {vehicleInfo.fuelType}
    //           </span>
    //         </div>
    //       )}

    //       {vehicleInfo.transmission && (
    //         <div className="flex justify-between text-sm">
    //           <span className="text-slate-500">
    //             {t("admin.fleet.vehicle.add.vehicle.transmission")}
    //           </span>
    //           <span className="text-slate-700 font-medium">
    //             {vehicleInfo.transmission}
    //           </span>
    //         </div>
    //       )}

    //       {vehicleInfo.maximumPowerHp && (
    //         <div className="flex justify-between text-sm">
    //           <span className="text-slate-500">
    //             {t("admin.fleet.vehicle.add.vehicle.maximumpower")}
    //           </span>
    //           <span className="text-slate-700 font-medium">
    //             {vehicleInfo.maximumPowerHp} HP /{" "}
    //             {vehicleInfo.maximumPowerKw} kW
    //           </span>
    //         </div>
    //       )}

    //       {vehicleInfo.cylinderCapacity && (
    //         <div className="flex justify-between text-sm">
    //           <span className="text-slate-500">
    //             {t("admin.fleet.vehicle.add.vehicle.cylindercapacity")}
    //           </span>
    //           <span className="text-slate-700 font-medium">
    //             {vehicleInfo.cylinderCapacity} cc
    //           </span>
    //         </div>
    //       )}
    //     </div>
    //   </div>
    // </div>
  );
};

export default memo(VehiclePickerSummary);
